import type { HygieneListParams } from '../../request/hygiene/hygieneRequests.ts';

/** Query key registry for Hygiene Check (Readiness). Everything for one audit year shares the year prefix. */

const root = ['hygiene-check'] as const;

export const hygieneQueryKeys = {
  all: root,
  year: (auditYearId: string) => [...root, 'year', auditYearId] as const,
  summary: (auditYearId: string) => [...root, 'year', auditYearId, 'summary'] as const,
  findings: (params: HygieneListParams) => [...root, 'year', params.audit_year_id, 'findings', params] as const,
  finding: (id: string) => [...root, 'finding', id] as const,
  scan: (id: string) => [...root, 'scan', id] as const,
  estimate: (auditYearId: string) => [...root, 'year', auditYearId, 'estimate'] as const,
  checks: () => [...root, 'checks'] as const,
  assignees: () => [...root, 'assignees'] as const,
} as const;
